import { render, staticRenderFns } from "./message-container.vue?vue&type=template&id=769a39da&scoped=true"
import script from "./message-container.vue?vue&type=script&lang=ts"
export * from "./message-container.vue?vue&type=script&lang=ts"
import style0 from "./message-container.vue?vue&type=style&index=0&id=769a39da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769a39da",
  null
  
)

export default component.exports